import React from "react"

import type {
    IPractice,
    ISimplifiedPractice,
} from "@common-shared/types/responseData/commonResponseData.types"

import { AvatarElement } from "@front-shared/elements/avatar.element"
import { PrimaryText } from "@front-shared/elements/primaryText.element"

export const InvitedPracticeElement: React.FunctionComponent<
    InvitedPracticeElementProps
> = props => {
    return (
        <div
            className={`
                px-[12px] py-[8px] rounded-[8px]
                flex items-center bg-brand-white
                border border-solid border-brand-warmShadow
                ${props.className}
            `}
        >
            <AvatarElement
                className="mr-[8px]"
                width={32}
                fontClassName="pt-[3px] text-[13px] leading-[13px]"
                user={props.practice}
            />

            <PrimaryText className="pt-[3px]" typography="textSemibold">
                {props.practice.name}
            </PrimaryText>
        </div>
    )
}

interface InvitedPracticeElementProps {
    className?: string
    practice: IPractice | ISimplifiedPractice
}
